import React from 'react'
import { Provider } from 'react-redux'
import { store } from './store'

const ReduxProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Provider store={store}>{children}</Provider>
)

export default ReduxProvider